import { render, staticRenderFns } from "./AcessarPedidoView.vue?vue&type=template&id=0764a4d9"
import script from "./AcessarPedidoView.vue?vue&type=script&lang=js"
export * from "./AcessarPedidoView.vue?vue&type=script&lang=js"
import style0 from "./AcessarPedidoView.vue?vue&type=style&index=0&id=0764a4d9&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports